module.exports = __webpack_public_path__ + "img/calendarstartDate.fe706388.svg";